import React from 'react';

import styles from '../../index.module.scss';

type TableHeaderProps = {
  columns: string[];
};

export const TableHeader: React.FC<TableHeaderProps> = ({ columns }) => {
  return (
    <thead>
      <tr>
        <th className={styles.timeTd} />
        {columns.map((column, index) => (
          <th key={index} className={styles.th}>
            {column}
          </th>
        ))}
      </tr>
    </thead>
  );
};
